import React, { Fragment, useState, useEffect } from 'react';
import { func, string } from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Input } from '@thd-olt-component-react/input';
import { Checkbox } from '@thd-olt-component-react/checkbox';
import { invalidEmailAndDisplayName, validateDisplayName, validateEmail } from '../helper';
import { ExistingUser } from './ExistingUser';

export const UserDetails = ({
  className, displayName, email, onDisplayNameChange, onEmailChange
}) => {
  const [details, setDetails] = useState({
    rememberMe: false,
    existingUser: false
  });
  let CookieUtils;
  useEffect(() => {
    async function initializeCookieUtils() {
      const { default: cookieUtils } = await import('cookie-utils');
      CookieUtils = cookieUtils;
    }
    initializeCookieUtils();
  }, []);


  useEffect(() => {
    if (!CookieUtils) return;
    CookieUtils.fed_CreateCookie('rememberMe', details.rememberMe, null);
    CookieUtils.fed_CreateCookie('displayName', details.rememberMe ? displayName : '', null);
    CookieUtils.fed_CreateCookie('email', details.rememberMe ? email : '', null);
  }, [details.rememberMe]);

  const toggleRemeberMe = (value) => {
    setDetails({
      rememberMe: value,
      existingUser: value
    })
  }

  const onNotMeButtonClick = () => {
    setDetails({
      ...details,
      existingUser: false
    })
  }

  return (
    <>
     {details.existingUser && (
       <ExistingUser
          displayName={displayName}
          email={email}
          onNotMeClick={() => onNotMeButtonClick()}
        />
      )}
      {!details.existingUser && (
        <Row>
          <Col xs={6}>
            <Row>
              <Col className="write-review-content__input-fields">
                <span className="write-review-content__input-fields__labels">Your Display Name</span>
                <Input
                  errorText="Display Name should use letters and numbers only (no space or symbols)"
                  validation={(displayName) => validateDisplayName(displayName)}
                  onChange={(displayName) => {
                    onDisplayNameChange(displayName);
                  }}
                  value={displayName}
                  scrollOnFocus
                />
              </Col>
            </Row>
            <span className="write-review-content__input-fields__instruction">
              Do not use your full name. Use letters and numbers only (no space or symbols).
            </span>
          </Col>
          <Col xs={6}>
            <Row>
              <Col className="write-review-content__input-fields">
                <span className="write-review-content__input-fields__labels">Your Email Address</span>
                <Input
                  errorText="Your email address is not in the proper format"
                  onChange={(email) => {
                    onEmailChange(email);
                  }}
                  validation={(email) => validateEmail(email)}
                  value={email}
                  scrollOnFocus
                />
              </Col>
            </Row>
            <span className="write-review-content__input-fields__instruction">
              Your email address will not be displayed publicly.
              Emails are used for notification purposes only
            </span>
          </Col>
        </Row>
      )}
      
      <Checkbox
        className={className}
        value="RememberMe"
        id="RememberMe"
        disabled={invalidEmailAndDisplayName({ email, displayName })}
        checked={details.rememberMe}
        onChange={() => toggleRemeberMe(!details.rememberMe)}
      >
        Remember me on this device.
      </Checkbox>
    </>
  );
};

UserDetails.displayName = 'WriteAReviewUserDetails';

UserDetails.propTypes = {
  className: string,
  displayName: string,
  email: string,
  onDisplayNameChange: func.isRequired,
  onEmailChange: func.isRequired
};

UserDetails.defaultProps = {
  className: null,
  displayName: '',
  email: ''
};
